import { useEffect } from "react";
import Analytics from "analytics";
import googleTagManager from "@analytics/google-tag-manager";
import { getCookieConsent } from "../helpers/getCookieConsent";

export const useAnalytics = () => {
  useEffect(() => {
    if (
      process.env.REACT_APP_ENABLE_ANALYTICS?.includes("true") &&
      getCookieConsent(document.cookie)
    ) {
      const analytics = Analytics({
        app: "appraisals",
        plugins: [
          googleTagManager({
            containerId: "GTM-NCZ86Q"
          })
        ]
      });
      
      window.gtag = function () {
        window.dataLayer.push(arguments);
      };

      analytics.page();
    }
  }, [location.pathname]);
};

export default useAnalytics;
